export default __webpack_public_path__ + "static/media/LetsFinalize.fa0651c6.png";